// Vista de login. Sin shell (no hay sidebar todavía: el usuario no está
// autenticado). Tras un login exitoso, no navega manualmente a '/' — deja
// que `onAuthStateChange` (estado-sesion.js) dispare la re-renderización
// del router al detectar la sesión nueva; main.js re-evalúa la guarda y
// redirige. Evita el caso borde de navegar antes de que `claims` (que
// depende del JWT ya con el Auth Hook aplicado) esté disponible.
//
// Incluye el modo "recuperar contraseña" como un segundo estado del mismo
// formulario — ver panel-cliente/src/js/vistas/login.js, mismo patrón.

import { mostrarToast } from '@plataforma/ui';
import { esCorreoValido } from '@plataforma/utils';

import { navegarA } from '../enrutador.js';
import {
  iniciarSesion,
  obtenerEstadoSesion,
  solicitarRecuperacionContrasena,
} from '../estado-sesion.js';

export function vistaLogin(contenedor) {
  // Si ya hay una sesión de super_admin activa, no tiene sentido mostrar
  // el formulario de nuevo.
  const { sesion, claims } = obtenerEstadoSesion();
  if (sesion && claims.rol === 'super_admin') {
    navegarA('/');
    return;
  }

  pintarFormularioLogin(contenedor);
}

function pintarFormularioLogin(contenedor) {
  contenedor.innerHTML = `
    <div class="pf-login">
      <form class="pf-tarjeta pf-login__tarjeta" id="pf-form-login" novalidate>
        <h1 class="pf-login__titulo">Panel Super Admin</h1>
        <p class="pf-texto-suave pf-login__subtitulo">Vimos Digital — acceso restringido a administradores de la plataforma.</p>

        <div class="pf-campo">
          <label for="pf-email">Correo</label>
          <input type="email" id="pf-email" name="email" autocomplete="username" required />
        </div>

        <div class="pf-campo">
          <label for="pf-password">Contraseña</label>
          <input type="password" id="pf-password" name="password" autocomplete="current-password" required />
        </div>

        <p class="pf-campo__error" id="pf-login-error" hidden></p>

        <button type="submit" class="pf-boton pf-boton--primario" id="pf-login-submit">
          Ingresar
        </button>

        <button type="button" class="pf-boton pf-boton--enlace" id="pf-login-olvide" style="margin-top: 12px;">
          ¿Olvidaste tu contraseña?
        </button>
      </form>
    </div>
  `;

  const form = contenedor.querySelector('#pf-form-login');
  const errorEl = contenedor.querySelector('#pf-login-error');
  const submitEl = contenedor.querySelector('#pf-login-submit');

  contenedor.querySelector('#pf-login-olvide').addEventListener('click', () => {
    pintarFormularioRecuperar(contenedor);
  });

  form.addEventListener('submit', async (evento) => {
    evento.preventDefault();
    errorEl.hidden = true;

    const email = form.email.value.trim();
    const password = form.password.value;

    if (!esCorreoValido(email)) {
      errorEl.textContent = 'Ingresa un correo válido.';
      errorEl.hidden = false;
      return;
    }
    if (!password) {
      errorEl.textContent = 'Ingresa tu contraseña.';
      errorEl.hidden = false;
      return;
    }

    submitEl.disabled = true;
    submitEl.textContent = 'Ingresando…';

    const { error } = await iniciarSesion(email, password);

    if (error) {
      errorEl.textContent = 'Correo o contraseña incorrectos.';
      errorEl.hidden = false;
      submitEl.disabled = false;
      submitEl.textContent = 'Ingresar';
    }
    // Sin error: se deja que onAuthStateChange/el router hagan el resto.
  });
}

function pintarFormularioRecuperar(contenedor) {
  contenedor.innerHTML = `
    <div class="pf-login">
      <form class="pf-tarjeta pf-login__tarjeta" id="pf-form-recuperar" novalidate>
        <h1 class="pf-login__titulo">Recuperar contraseña</h1>
        <p class="pf-texto-suave pf-login__subtitulo">
          Ingresa tu correo y te enviaremos un enlace para elegir una nueva contraseña.
        </p>

        <div class="pf-campo">
          <label for="pf-recuperar-email">Correo</label>
          <input type="email" id="pf-recuperar-email" name="email" autocomplete="username" required />
        </div>

        <p class="pf-campo__error" id="pf-recuperar-error" hidden></p>

        <button type="submit" class="pf-boton pf-boton--primario" id="pf-recuperar-submit">
          Enviar enlace
        </button>

        <button type="button" class="pf-boton pf-boton--enlace" id="pf-recuperar-volver" style="margin-top: 12px;">
          Volver a iniciar sesión
        </button>
      </form>
    </div>
  `;

  contenedor.querySelector('#pf-recuperar-volver').addEventListener('click', () => {
    pintarFormularioLogin(contenedor);
  });

  const form = contenedor.querySelector('#pf-form-recuperar');
  const errorEl = contenedor.querySelector('#pf-recuperar-error');
  const submitEl = contenedor.querySelector('#pf-recuperar-submit');

  form.addEventListener('submit', async (evento) => {
    evento.preventDefault();
    errorEl.hidden = true;

    const email = form.email.value.trim();
    if (!esCorreoValido(email)) {
      errorEl.textContent = 'Ingresa un correo válido.';
      errorEl.hidden = false;
      return;
    }

    submitEl.disabled = true;
    submitEl.textContent = 'Enviando…';

    await solicitarRecuperacionContrasena(email);

    mostrarToast('Si el correo existe, te llegará un enlace para restablecer tu contraseña.', {
      tono: 'exito',
      duracionMs: 8000,
    });

    pintarFormularioLogin(contenedor);
  });
}
